import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  text: 'Compras (es discreto, nadie sabrá).'
}, {
  num: '02',
  text: 'Lo lees hoy, antes de volver a escribirle.'
}, {
  num: '03',
  text: 'Recuperas tu vida en menos de una semana.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 px-5 bg-[#FAF5EE]" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-5xl text-[#5C1A2B] mb-12 text-center leading-tight" data-id="element-102">
          3 pasos. Una semana.
        </motion.h2>

        <div className="space-y-8 md:space-y-10" data-id="element-103">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex items-center gap-6 md:gap-10" data-id="element-104">
              <div className="font-serif text-5xl md:text-7xl text-[#F2EBE1] font-bold tracking-tighter flex-shrink-0" style={{
            WebkitTextStroke: '1px #C86B5E',
            color: 'transparent'
          }} data-id="element-105">
                {step.num}
              </div>
              <p className="text-lg md:text-xl text-[#2D2D2D] font-light leading-snug" data-id="element-106">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}